import { CloudinaryProductAsset } from 'shared/types/content';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import { getMediaId } from '../cloudinary/media-id';

export const isCloudinaryImage = (asset: CloudinaryProductAsset) =>
  ['jpg', 'png', 'webp'].includes(asset.format);

export const cloudinaryAssetToImage = (asset: CloudinaryProductAsset): ImageProps => ({
  src: asset.publicId,
  alt: asset.alt,
  media: { mediaId: getMediaId(asset), alt: asset.alt },
});

// Keep only displayable Cloudinary images, drop duplicates by assetId (preserving order),
// and map to gallery ImageProps. Shared by the PDP gallery mapper and the finish-image hook.
export const dedupeCloudinaryImages = (assets: CloudinaryProductAsset[]): ImageProps[] => {
  const seenAssetIds = new Set<string>();
  return assets
    .filter((asset) => {
      if (!isCloudinaryImage(asset) || seenAssetIds.has(asset.assetId)) return false;
      seenAssetIds.add(asset.assetId);
      return true;
    })
    .map(cloudinaryAssetToImage);
};
